
export function isDefined<T>(val: T | undefined | null): val is T {
    return val !== undefined && val !== null;
}

export type CompareFunc<T> = (a: T, b: T) => number;
export type GetterFunc<T, R> = (item: T) => R;

export function CompareAsc<T, R>(getter: (i: T) => R): CompareFunc<T>
{
    let compareFunc: CompareFunc<T> = function(a: T, b: T)
    {
        let aval: R = getter(a);
        let bval: R = getter(b);

        if (aval < bval) return -1;
        else if (aval > bval) return 1;
        else return 0;
    }

    return compareFunc;
}

export function CompareDesc<T, R>(getter: (i: T) => R): CompareFunc<T>
{
    let compareFunc: CompareFunc<T> = function(a: T, b: T)
    {
        let aval: R = getter(a);
        let bval: R = getter(b);

        if (aval < bval) return 1;
        else if (aval > bval) return -1;
        else return 0;
    }

    return compareFunc;
}

// async delay function
export function delay(ms: number): Promise<void>
{
    return new Promise<void>(resolve => setTimeout(resolve, ms));
}